import React from 'react';
import {
  ConsentAnswer,
  consentAnswerOptions,
} from './VoiceTranscribingConsentOptions';

interface UnderstandStatementQuestionProps {
  value: ConsentAnswer;
  onChange: (value: ConsentAnswer) => void;
}

const UnderstandStatementQuestion: React.FC<
  UnderstandStatementQuestionProps
> = ({ value, onChange }) => {
  return (
    <div className="mt-2 govuk-bp:mt-5">
      <div className="govuk-form-group">
        <fieldset className="govuk-fieldset">
          <legend className="govuk-fieldset__legend govuk-fieldset__legend--l">
            <h1 className="govuk-fieldset__heading">
              Do you understand the statement above?
            </h1>
          </legend>

          <div className="govuk-radios" data-module="govuk-radios">
            {consentAnswerOptions.map(option => {
              const optionId = `understands-statement-${option.value}`;
              return (
                <div className="govuk-radios__item" key={option.value}>
                  <input
                    className="govuk-radios__input"
                    id={optionId}
                    name="understandsStatement"
                    type="radio"
                    value={option.value}
                    checked={value === option.value}
                    onChange={() => onChange(option.value)}
                  />
                  <label
                    className="govuk-label govuk-radios__label"
                    htmlFor={optionId}
                  >
                    {option.label}
                  </label>
                </div>
              );
            })}
          </div>
        </fieldset>
      </div>
    </div>
  );
};

export default UnderstandStatementQuestion;
